const de = {
  title: 'Kacheleinstellungen',
  systemTiles: 'System Kacheln',
  defaultTiles: 'Vordefinierte Kacheln',
  categoryIcon: 'Kategorie Symbol',
  defaultIcon: 'Default Symbol',
  tooltips: {
    categoryIcon: 'Icon für die Kategorien',
    defaultIcon: 'Icon welches von jedem Benutzer verwendet werden kann'
  },
  alerts: {
    successfulIconCreate: 'Das Default-Icon wurde erstellt.'
  }
};

export default de;
export type TileSettingsTranslation = typeof de;
